import * as _config from './config';
import * as $ from 'jquery';
import { BehaviorSubject } from 'rxjs';
import * as moment from 'moment';
import { observable, computed } from 'mobx';
import { ValidationError, Entity, SaveResult, EntityState } from 'breeze-client';
import { ToastrService } from 'ngx-toastr';

export function getCurrentDate(): Date {
    return new Date();
}

// Provisional version returns validation error messages 
// of first entity that failed to save
export function getSaveValidationErrorMessage(saveError: { entityErrors: ValidationError[]; }): string {
    try {// return the first entity's error message(s)
        return 'Validation Error: ' + saveError.entityErrors[0].errorMessage;
    } catch (e) {// ignore problem extracting error message 
        return "Save validation error";
    }
}

// Return string of an entity's validation error messages 
export function getEntityValidationErrorMessage(entity: Entity): string {
    try {
        var errs = entity.entityAspect.getValidationErrors();
        var errmsgs = errs.map(function (ve) { return ve.errorMessage; });
        return errmsgs.length ? errmsgs.join("; ") : "no validation errors";
    } catch (e) {
        return "not an entity";
    }
}

export function decodeHtml(html: string) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
}

export function isMobileSafari() {
    return navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/) && !navigator.userAgent.match(/CriOS/);
}

export function numberWithCommas(x: number, round?: number): string {
    var y = 0;
    if (x)
        y = x;

    var parts = (round === null ? y.toString() : y.toFixed(round)).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

export function camelCaseDto(dto: any): any {
    var m = {};
    $.map(dto, function (prop, propName: string) {
        m[propName.charAt(0).toLowerCase() + propName.slice(1)] = dto[propName];
    });

    return m;
}
export class Store {
    expires1Day: Date;
    expires30Days: Date;

    constructor() {
        this.expires1Day = moment().add(_config.dayMs, "ms").toDate();
        this.expires30Days = moment().add(_config.storeExpirationMs, "ms").toDate();
    }

    clear(key: string) {
        localStorage.removeItem(key);
    }

    fetch(key: string): string {
        var cache = localStorage.getItem(key);
        if (cache) {
            var item: storageItem = JSON.parse(cache);
            if (moment().isSameOrBefore(item.expires)) {
                return item.item;
            } else {
                this.clear(key);
            }
        }

        return null;
    }

    save(key: string, value: string) {
        var item: storageItem = {
            item: value,
            expires: this.expires30Days
        }
        var cache = JSON.stringify(item);

        localStorage.setItem(key, cache);
    }

    saveForADay(key: string, value: string) {
        var item: storageItem = {
            item: value,
            expires: this.expires1Day
        }
        var cache = JSON.stringify(item);

        localStorage.setItem(key, cache);
    }
}

export function onlyUnique(value: string, index: number, self: Array<string>) {
    return self.indexOf(value) === index;
}

export var store = new Store();

export function koPropIfAvailable(item: BehaviorSubject<any>, propName: string, defaultValue: any): any {
    if (item && item.value)
        if (item.value[propName] && typeof item.value[propName] === 'function')
            return item.value[propName]();
        else if (item.value[propName])
            return item.value[propName];
    return defaultValue;
}

export function formatSavedMessage(saveResult: SaveResult) {
    var result = "";

    saveResult.entities.forEach(function (entity: meta.MetaEntity) {
        if (entity.entityAspect.valueQueue) {
            if (entity.entityAspect.fieldsSavingEntityState === EntityState.Modified) {

                for (var field in entity.entityAspect.fieldsSaving) {
                    if (entity.entityAspect.valueQueue[field]) {
                        entity.entityAspect.valueQueue[field].orig = entity[field]();
                        entity.entityAspect.valueQueue[field].isSaved = true;
                    }
                }
            }
        }

        if (result.length)
            result += "<br />";

        if (entity.entityAspect.fieldsSavingEntityState === EntityState.Deleted || (entity.hasOwnProperty("isDeleted") && entity.isDeleted && (entity.entityAspect.fieldsSaving["isDeleted"] !== undefined && entity.isDeleted === true))) {
            if (entity.entityAspect.delMsg) {
                result = entity.entityAspect.delMsg;
            } else if (entity.name) {
                result = _config.resx.toasts.entityDeleted.replace(/\{0\}/gi, entity.name);
            }
        } else if (entity.entityAspect.fieldsSavingEntityState === EntityState.Added || (entity.hasOwnProperty("isDeleted") && entity.isDeleted && (entity.entityAspect.fieldsSaving["isDeleted"] !== undefined && !entity.isDeleted))) {
            if (entity.entityAspect.addMsg) {
                result = entity.entityAspect.addMsg;
            } else if (entity.name) {
                result = _config.resx.toasts.entityAdded.replace(/\{0\}/gi, entity.name);
            }

        } else if (entity.entityAspect.fieldsSavingEntityState === EntityState.Modified) {
            for (var field in entity.entityAspect.fieldsSaving) {
                if (_config.skipFieldsForMessage.indexOf(field) >= 0)
                    continue;

                var fieldName = entity.entityType.props[field].displayName;
                var fieldValue = entity[field];

                if (/.+Id$/gi.test(field)) {
                    var actualField = field.replace(/Id$/gi, "");
                    if (entity[actualField]) {
                        var actualEntity = entity[actualField];
                        if (actualEntity && actualEntity.name) {
                            fieldValue = actualEntity.name;
                        }
                    }
                }


                if (fieldValue && fieldValue.length > 28) {
                    fieldValue = fieldValue.substring(0, 25) + "...";
                }
                result += fieldName + ": " + fieldValue + "<br />"
            }
        }

        result = result.replace(/<br \/>$/gi, "");

        entity.entityAspect.fieldsSaving = {};
    });

    return result;
}

interface listPickerData {
    isSelected: BehaviorSubject<boolean>,
    name
}

export class ListPicker<T> {
    expand = new BehaviorSubject(true);

    toggle = () => {
        this.expand.next(!this.expand.value);
    }

    allData: BehaviorSubject<T[]>;

    mapToString: (item: T) => string;

    name: string = "";

    selectAll = { isSelected: new BehaviorSubject(true), name: 'Select All' };

    private isAutoDeselecting = false;

    private availableBase = new BehaviorSubject<listPickerData[]>([]);
    available = new BehaviorSubject<listPickerData[]>([]);
    selected = new BehaviorSubject<string[]>([]);

    updateData() {
        if (this.selected.value.length === this.availableBase.value.length && !this.selectAll.isSelected.value) {
            this.isAutoDeselecting = true;
            this.selectAll.isSelected.next(true);
        } else if (this.selected.value.length < this.availableBase.value.length && this.selectAll.isSelected.value) {
            this.isAutoDeselecting = true;
            this.selectAll.isSelected.next(false);
        }
    }

    constructor(name: string, data: BehaviorSubject<T[]>, mapToStringCallback: (item: T) => string) {
        this.name = name;
        this.allData = data;
        this.allData.subscribe(val => {
            var items = val
                .map(this.mapToString)
                .filter(onlyUnique)
                .sort()
                .map((data) => {
                    return { isSelected: new BehaviorSubject(true), name: data };
                });

            this.availableBase.next(items);
        });
        this.mapToString = mapToStringCallback;

        this.selectAll.isSelected.subscribe((val) => {
            if (this.isAutoDeselecting === false) {
                this.availableBase.value.forEach((item) => { item.isSelected.next(val); });
            }
            else {
                this.isAutoDeselecting = false;
            }

            this.updateData();
        });

        this.availableBase.subscribe(val => {
            var availableItems = this.availableBase.value;
            this.available.next(availableItems);

            var selectedItems = val
                .filter((item) => item.isSelected.value)
                .map((item) => item.name);
            this.selected.next(selectedItems);

            this.updateData();
        });

        //this.available();
        //this.selected();
        //this.autoReselectAll();
    }

    isSelected(item): boolean {
        if (this.selectAll.isSelected.value)
            return true;

        if (this.selected.value.length === 0)
            return false;

        var value = this.mapToString(item);
        return this.selected.value.indexOf(value) !== -1;
    }
}

export class DateRangePicker<T> {
    expand = new BehaviorSubject(true);

    toggle = () => {
        this.expand.next(!this.expand.value);
    }

    allData: BehaviorSubject<T[]>;

    mapToDate: (item: T) => Date;

    name: string = "";

    selectAll = { isSelected: new BehaviorSubject(true), name: 'Select All' };

    minDate = new BehaviorSubject<Date>(null);

    maxDate = new BehaviorSubject<Date>(null);

    constructor(name: string, data: BehaviorSubject<T[]>, mapToDateCallback: (item: T) => Date) {
        this.name = name;
        this.allData = data;
        this.mapToDate = mapToDateCallback;

        this.minDate.subscribe((val) => {
            if (val && this.selectAll.isSelected.value)
                this.selectAll.isSelected.next(false);

            if (!val && !this.maxDate.value)
                this.selectAll.isSelected.next(true);
        });

        this.maxDate.subscribe((val) => {
            if (val && this.selectAll.isSelected.value)
                this.selectAll.isSelected.next(false);

            if (!val && !this.minDate.value)
                this.selectAll.isSelected.next(true);
        });
    }

    isSelected(item): boolean {
        if (this.selectAll.isSelected.value)
            return true;

        var value = this.mapToDate(item);
        if (!value)
            return false;

        if (this.minDate.value && moment(value).isBefore(this.minDate.value))
            return false;

        if (this.maxDate.value && moment(value).isAfter(moment(this.maxDate.value).endOf("day")))
            return false;

        return true;
    }
}

export var emptyPromise = new Promise<any>((resolve) => { resolve(null); });
